export function typeOfV2({ v2 }) {
  let type = typeof v2;
  if (type === 'object' && Array.isArray(v2)) {
    type = 'array';
  }
  if (type === 'object' && v2 instanceof Date) {
    type = 'date';
  }
  if (!['string', 'number', 'array', 'date'].includes(type)) {
    throw new Error(`El valor del filtro tiene un tipo "${type}" desconocido`);
  }
  return type;
}
